export default __webpack_public_path__ + "static/media/e-bupot-picturemark-d.bb4d9069.svg";